import { Table } from "@/features/Table";
import { useLocation } from "react-router";
import { Tables } from "@/gen/tableNames/tables";
import { Clients } from "@/lib/clients";
import { type S1MonthlyComments, s1_monthly_comments_columns } from "./columns";
import {
  type FilterS1MonthlyCommentsSchema,
  FilterS1MonthlyComments,
} from "./filter";

export const S1MonthlyCommentsTable = () => {
  const location = useLocation();
  const baseUrl = location.pathname;

  return (
    <Table<S1MonthlyComments, FilterS1MonthlyCommentsSchema>
      label="S1 Monthly comments"
      client={Clients.S1_QUANTILIA}
      table_name={Tables.S1_MONTHLY_COMMENTS}
      columns={s1_monthly_comments_columns}
      filter={<FilterS1MonthlyComments />}
      actions={[
        {
          label: "actions.new",
          route: `${baseUrl}/new`,
        },
      ]}
    />
  );
};
